let active_elements = [];

export function register_click_outside_element(element) {
  active_elements.push(element);
  return () => {
    const index = active_elements.indexOf(element);
    if (index > -1) {
      active_elements.splice(index, 1);
    }
  };
}

export function handle_click_outside(event) {
  // Create a copy to avoid modification during iteration
  const elements = [...active_elements];
  for (const element of elements) {
    const target = event.target;
    if (!element.el?.contains(target) && !element.anchor?.contains(target)) {
      element.on_click_outside?.(event);
    }
  }
}

export function handle_escape(event) {
  if (event.key === 'Escape' && active_elements.length > 0) {
    // Close the last registered element
    const last_element = active_elements[active_elements.length - 1];
    last_element.on_click_outside?.(event);
  }
}

// Usage example:
/*
$effect(() => {
  if (is_open && menu_container) {
    const unregister = register_click_outside_element({
      el: menu_container,
      on_click_outside: () => {
        is_open = false;
        // or:
        popover_ref?.hidePopover();
      }
    });
    return unregister;
  }
});
*/
